/**
 * Fit Guidance & Size Guide Modal
 * Handles modal open/close, mobile drag-to-close, ESC key, and focus trap
 */
(function () {
  'use strict';

  function initSizeGuideModal() {
    var modals = document.querySelectorAll('.size-guide-modal');

    modals.forEach(function (modal) {
      if (modal.dataset.initialized === 'true') return;
      modal.dataset.initialized = 'true';

      var blockId = modal.id.replace('size-guide-modal-', '');
      var openLink = document.getElementById('open-fit-guidance-modal-' + blockId);
      var overlay = document.getElementById('size-guide-overlay-' + blockId);
      var closeBtn = document.getElementById('size-guide-close-' + blockId);
      var dragHandle = document.getElementById('size-guide-drag-handle-' + blockId);

      if (!openLink || !overlay) return;

      var startY = 0;
      var currentY = 0;
      var isDragging = false;
      var DRAG_THRESHOLD = 100;
      var isMobile = function () { return window.innerWidth <= 768; };

      function openModal(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }

        // Compensate for scrollbar width to prevent page shift
        var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = scrollbarWidth + 'px';
        }

        if (isMobile()) {
          // Use window.innerHeight (actual visible height) instead of vh units
          // vh on iOS includes browser chrome so it's unreliable
          var modalHeight = Math.round(window.innerHeight * 0.55);
          modal.style.height = modalHeight + 'px';
          modal.style.maxHeight = modalHeight + 'px';
          modal.style.transform = 'translateY(100%)';
          modal.style.transition = 'transform 0.3s ease-out';
        }

        overlay.classList.add('active');
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';

        if (isMobile()) {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              modal.style.transform = 'translateY(0)';
            });
          });
        }

        // Focus trap: focus the close button or modal
        if (closeBtn) {
          closeBtn.focus();
        }
      }

      function closeModal(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }

        if (isMobile()) {
          modal.style.transform = 'translateY(100%)';
          setTimeout(function () {
            overlay.classList.remove('active');
            modal.classList.remove('active');
            modal.style.height = '';
            modal.style.maxHeight = '';
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
          }, 300);
        } else {
          overlay.classList.remove('active');
          modal.classList.remove('active');
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }

        // Return focus to trigger
        if (openLink) {
          openLink.focus();
        }
      }

      // Open
      openLink.addEventListener('click', openModal);

      // Close on overlay
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal(e);
      });

      // Close button
      if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
      }

      // ESC key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('active')) {
          closeModal(e);
        }
      });

      // Mobile drag-to-close
      function handleTouchStart(e) {
        startY = e.touches[0].clientY;
        isDragging = true;
        modal.style.transition = 'none';
      }

      function handleTouchMove(e) {
        if (!isDragging) return;
        currentY = e.touches[0].clientY;
        var deltaY = currentY - startY;

        if (deltaY > 0) {
          e.preventDefault();
          var moveY = Math.min(deltaY, window.innerHeight * 0.6);
          modal.style.transform = 'translateY(' + moveY + 'px)';

          var opacity = 1 - moveY / (window.innerHeight * 0.4);
          overlay.style.opacity = String(Math.max(0.3, opacity));
        }
      }

      function handleTouchEnd() {
        if (!isDragging) return;
        isDragging = false;
        modal.style.transition = 'transform 0.3s ease-out';

        var deltaY = currentY - startY;
        if (deltaY > DRAG_THRESHOLD) {
          closeModal();
        } else {
          modal.style.transform = 'translateY(0)';
          overlay.style.opacity = '1';
        }
      }

      if (dragHandle) {
        dragHandle.addEventListener('touchstart', handleTouchStart, { passive: false });
        dragHandle.addEventListener('touchmove', handleTouchMove, { passive: false });
        dragHandle.addEventListener('touchend', handleTouchEnd);
      }

      var modalHeader = modal.querySelector('.size-guide-modal-header');
      if (modalHeader) {
        modalHeader.addEventListener('touchstart', handleTouchStart, { passive: false });
        modalHeader.addEventListener('touchmove', handleTouchMove, { passive: false });
        modalHeader.addEventListener('touchend', handleTouchEnd);
      }

      // Reset modal styles on resize
      window.addEventListener('resize', function () {
        if (modal.classList.contains('active')) {
          if (!isMobile()) {
            modal.style.transform = '';
            modal.style.height = '';
            modal.style.maxHeight = '';
          } else {
            // Recalculate height on resize (e.g. orientation change)
            var modalHeight = Math.round(window.innerHeight * 0.55);
            modal.style.height = modalHeight + 'px';
            modal.style.maxHeight = modalHeight + 'px';
          }
        }
      });
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuideModal);
  } else {
    initSizeGuideModal();
  }

  // Re-initialize on section reload
  document.addEventListener('shopify:section:load', initSizeGuideModal);

  // Update fit-guidance tag text on variant change
  var pdpFitMessages = {};
  var fitMsgWrapper = document.querySelector('.fit-guidance__wrapper[data-fit-messages]');
  if (fitMsgWrapper) {
    try {
      pdpFitMessages = JSON.parse(fitMsgWrapper.getAttribute('data-fit-messages') || '{}');
    } catch (e) {}
  }

  function applyFitTagText(tag, text) {
    var parts = text.split(' based on');
    tag.innerHTML = '';
    if (parts.length > 1) {
      var boldSpan = document.createElement('span');
      boldSpan.className = 'fit-guidance__tag-bold';
      boldSpan.textContent = parts[0];
      var lightSpan = document.createElement('span');
      lightSpan.className = 'fit-guidance__tag-light';
      lightSpan.textContent = ' based on' + parts[1];
      tag.appendChild(boldSpan);
      tag.appendChild(lightSpan);
    } else {
      tag.textContent = text;
    }
  }

  if (typeof $ !== 'undefined') {
    $(document).on('variantChange', '[data-section-type="product"]', function (e) {
      var variant = e.variant;
      if (!variant) return;
      var fitMsg = pdpFitMessages[variant.id] || pdpFitMessages[String(variant.id)];
      var tags = document.querySelectorAll('.fit-guidance__tag[data-block-id]');
      tags.forEach(function (tag) {
        var fallback = tag.getAttribute('data-fit-fallback') || '';
        var text = fitMsg || fallback;
        applyFitTagText(tag, text);
      });
    });
  }
})();
